const defaultPermissionRole = {};

const defaultPermissionEntities = {};

const permissionRole = {};

const permissionEntities = {};

export const authRole = (role) => {
    return permissionRole[role] || defaultPermissionRole;
};

export const authEntities = (role) => {
    return permissionEntities[role] || defaultPermissionEntities;
};